import styled from "styled-components";
import {Modal} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-footer {
        border-top: none !important;
    }
`;

export const HistoryList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HistoryEntry = styled.div`
    display: flex;
    gap: 16px;
    padding: 20px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const HistoryIconColumn = styled.div`
    flex-shrink: 0;
    width: 32px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 4px;
`;

export const HistoryContentColumn = styled.div`
    flex: 1;
    min-width: 0;
`;

export const HistoryMetaColumn = styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    min-width: 140px;
`;

export const ActionTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    color: ${props => props.$color || "#262626"};
    margin-bottom: 4px;
`;

export const ActionUser = styled.div`
    font-size: 13px;
    color: rgb(0, 0, 0);
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const ActionReason = styled.div`
    margin-top: 8px;
    font-size: 13px;
    color: #595959;
    line-height: 1.5;
`;

export const ActionDate = styled.div`
    font-size: 13px;
    color: #8c8c8c;
    white-space: nowrap;
`;

export const EmptyState = styled.div`
    padding: 32px 0;
    text-align: center;
    color: #8c8c8c;
`;

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 8px;
`;

export const ModalTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
`;
